import { render, staticRenderFns } from "./EmployeeSalarySettingDelete.vue?vue&type=template&id=1d205daa&scoped=true&"
import script from "./EmployeeSalarySettingDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d205daa",
  null
  
)

export default component.exports